export default {
  ktReco: {
    style: 'ktReco',
    path: 'lily/ktReco',
    cardsRatio: '1.4',
    cards: {
      central: {
        text: `Synthèse des recommandations pour les cathéters centraux`,
        action: 'Télécharger',
        link: require('@/assets/documents/tools/lily/ktReco/SPIADI - Synthèse des recommandations - cathéters centraux.pdf')
      },
      mid: {
        action: 'Télécharger',
        text: `Synthèse des recommandations pour les cathéters veineux de type midline avec prolongateur intégré`,
        link: require('@/assets/documents/tools/lily/ktReco/SPIADI - Synthèse des recommandations - midline avec PI.pdf')
      },
      peri: {
        action: 'Télécharger',
        text: `Synthèse des recommandations pour les cathéters veineux périphériques courts et midlines sans prolongateur intégré`,
        link: require('@/assets/documents/tools/lily/ktReco/SPIADI - Synthèse des recommandations - CVP courts et midline sans PI.pdf')
      }
    }
  },

  midline: {
    style: 'midline',
    path: 'midline',
    texts: [
      `<span style="font-size: 150%; font-weight: bold;">MIDline Express</span> est un
outil pédagogique de formation qui vise à améliorer les pratiques lors de la
pose, les manipulations proximales et les réfections de pansement des MIDlines
avec prolongateur intégré.`,
      'Vous trouverez ci-dessous un guide explicatif, une affiche pour annoncer la formation aux professionnels et au choix : un diaporama commenté ou une vidéo.'

    ],
    cards: {
      guide: {
        type: 'Guide',
        action: 'Télécharger',
        text: `Mettez en place vos sessions de formation grâce à ce guide`,
        link: 'https://www.cpias-centre.fr/wp-content/uploads/2025/01/2025-SPIADI-GUIDE-MIDLINE.pdf'
      },
      poster: {
        type: 'Affiche',
        action: 'Télécharger',
        text: `Annoncez la date et le lieu de votre formation dans le service avec cette affiche`,
        link: `https://www.cpias-centre.fr/wp-content/uploads/2025/02/2025-SPIADI-AFFICHE-MIDLINE.pdf`
      },
      slide: {
        type: 'Diaporama',
        action: 'Télécharger',
        text: `Présentez l'outil pédagogique à l'aide du diaporama animé`,
        link: 'https://www.cpias-centre.fr/wp-content/uploads/2025/02/2025-SPIADI-DIAPO-MIDLINE.pptx'
      }
    },
    videos: [
      {
        dl: 'https://video.ploud.fr/download/streaming-playlists/hls/videos/df9a5365-3590-46bc-915a-7b591a20fad4-720-fragmented.mp4',
        url: 'https://l.cpias-centre.fr/midline-express'
      }
    ]
  },

  gloves: {
    style: 'gloves',
    path: 'gloves',
    texts: [
      `<span style="font-size: 150%; font-weight: bold;">Les gants, à quoi ça sert ?</span> est un outil
pédagogique de formation qui a pour objectif de promouvoir 5 messages clés autour du bon usage des gants.`,
      `Vous trouverez ci-dessous l'outil, ainsi qu'une vidéo et des affiches.`
    ],
    cards: {
      guide: {
        type: 'Guide',
        action: 'Télécharger',
        text: `Mettez en place vos sessions de formation grâce à ce guide`,
        link: `https://www.cpias-centre.fr/wp-content/uploads/2023/01/2022-CPIAS-OUTIL-GANTS.pdf`
      },

      poster: {
        type: 'Affiches',
        action: 'Télécharger',
        text: `Transmettez le QR code de la vidéo dans le service avec l'une de ces affiches`,
        link: `https://www.cpias-centre.fr/wp-content/uploads/2023/01/2022-CPIAS-AFFICHETTES-GANTS.pdf`
      },

      slide: {
        type: 'Diaporama',
        action: 'Télécharger',
        text: `Présentez l'outil pédagogique à l'aide du diaporama animé`,
        link: 'https://www.cpias-centre.fr/wp-content/uploads/2023/07/2022-CPIAS-DIAPO-GANT.pptx'
      }
    },
    videos: [
      {
        dl: 'https://video.ploud.fr/download/streaming-playlists/hls/videos/b185fa5e-b9be-4360-acc8-a953d7c6fe09-720-fragmented.mp4',
        url: 'https://l.spiadi.fr/outil-gants-2022'
      }
    ]
  },

  cleanhandprox: {
    style: 'cleanHandProx',
    path: 'cleanhandprox',
    texts: [
      `<span style="font-size: 150%; font-weight: bold;">CleanHandProx</span> est un outil
pédagogique de formation qui vise à améliorer les pratiques de manipulations proximales des cathéters centraux.`,
      `Vous trouverez ci-dessous le guide de mise en place d'une formation CleanHandPROX, le diaporama des résultats
de l'étude ainsi que les trois films utilisables lors de la formation.`
    ],
    cards: {
      guide: {
        type: `Guide de formation`,
        action: 'Télécharger',
        text: `Mettez en place vos sessions de formation grâce à ce guide`,
        link: 'https://l.spiadi.fr/cleanhandprox-guide'
      },

      poster: {
        type: 'Affiche',
        action: 'Télécharger',
        text: `Annoncez la date et le lieu de votre formation dans le service avec cette affiche`,
        link: 'https://www.cpias-centre.fr/wp-content/uploads/2024/06/2024-CPIAS-AFFICHE-CLEANHANDPROX.pdf'
      },

      slide: {
        type: 'Diaporama des résultats',
        action: 'Télécharger',
        text: `Animez la formation CleanHandProx à l'aide de ce diaporama`,
        link: 'https://l.spiadi.fr/cleanhandprox-results'
      }
    },
    videos: [
      {
        title: 'Film sans erreur',
        url: 'https://l.spiadi.fr/cleanhandprox-scenario1',
        dl: 'https://l.spiadi.fr/cleanhandprox-scenario1-dl'
      },
      {
        title: `Film avec erreur <br><small>Hygiène des mains manquante avant l'enfilage des gants stériles</small»`,
        url: 'https://l.spiadi.fr/cleanhandprox-scenario2',
        dl: 'https://l.spiadi.fr/cleanhandprox-scenario2-dl'
      },

      {
        title: 'Film avec erreur <br><small>Pas de gants stériles</small>',
        url: 'https://l.spiadi.fr/cleanhandprox-scenario3',
        dl: 'https://l.spiadi.fr/cleanhandprox-scenario3-dl'
      }
    ]
  },

  outfit: {
    style: 'outfit',
    path: 'outfit',
    texts: [
      `<span style="font-size: 150%; font-weight: bold;">Tenue et Soins, quel dress-code ?</span> est un outil pédagogique sur
        la tenue professionnelle<br> en établissements de santé, en établissements médico-sociaux et en ville
dans le cadre des précautions standard, hors contexte Covid.`,
      'Cet outil peut être utilisé par les EOH ou directement par les professionnels de santé.',
      'Vous trouverez ci-dessous un guide explicatif, des affiches pour annoncer la formation aux professionnels et une vidéo.'
    ],
    cards: {
      guide: {
        type: 'Guide pratique',
        action: 'Télécharger',
        text: `Mettez en place vos sessions de formation grâce au guide pratique`,
        link: `https://www.cpias-centre.fr/wp-content/uploads/2023/10/2023-CPIAS-GUIDE-DRESS-CODE.pdf`
      },

      poster: {
        type: 'Affiches',
        action: 'Télécharger',
        text: `Annoncez la date et le lieu de votre formation dans le service avec l'une de ces affiches`,
        link: 'https://www.cpias-centre.fr/wp-content/uploads/2023/11/Affiches-Tenue.zip'
      }
    },
    videos: [
      {
        dl: 'https://video.ploud.fr/download/streaming-playlists/hls/videos/9dd98566-888f-4e43-937b-2d8b176fa813-720-fragmented.mp4',
        url: 'https://video.ploud.fr/videos/embed/9dd98566-888f-4e43-937b-2d8b176fa813?api=1'
      }
    ]
  },

  cleanhand4: {
    style: 'cleanHand4',
    path: 'cleanhand4',
    texts: [
      `<span style="font-size: 150%; font-weight: bold;">CleanHand4</span> est un outil
pédagogique de formation qui vise à améliorer l’hygiène des mains lors
de la pose d’un cathéter veineux périphérique court.`,
      `Vous trouverez ci-dessous la box de formation CleanHand4 ainsi que son guide d'utilisation.`
    ],
    cards: {
      guidevideo: {
        type: `Guide pour une session de formation`,
        action: 'Télécharger',
        text: `Mettez en place vos sessions de formation utilisant les vidéos de simulation grâce à ce guide`,
        link: 'https://l.spiadi.fr/cleanhand4-guide-video'
      },

      poster: {
        type: 'Affiche',
        action: 'Télécharger',
        text: `Annoncez la date et le lieu de votre formation dans le service avec cette affiche`,
        link: 'https://www.cpias-centre.fr/wp-content/uploads/2025/01/2025-SPIADI-AFFICHE-CLEANHAND4.pdf'
      },

      guide: {
        type: `Guide d'utilisation de la Box`,
        action: 'Télécharger',
        text: `Apprenez à utiliser la Box CleanHand4 grâce à ce guide`,
        link: 'https://l.spiadi.fr/cleanhand4-guide-box'
      },
      box: {
        type: 'Box CleanHand4',
        action: 'Télécharger',
        text: `Animez la formation CleanHand4 à l'aide de ce diaporama`,
        link: 'https://l.spiadi.fr/cleanhand4-box-2'
      }
    },

    videos: [
      {
        title: `Film sans erreur`,
        url: 'https://l.spiadi.fr/cleanhand4-scenario3',
        dl: 'https://l.spiadi.fr/cleanhand4-scenario3-dl'
      },
      {
        title: `Film avec erreur
<br><small>Une hygiène des mains manquante</small»`,
        url: 'https://l.spiadi.fr/cleanhand4-scenario1',
        dl: 'https://l.spiadi.fr/cleanhand4-scenario1-dl'
      },
      {
        title: `Film avec erreur
<br><small>Deux hygiènes des mains manquantes</small»`,
        url: 'https://l.spiadi.fr/cleanhand4-scenario2',
        dl: 'https://l.spiadi.fr/cleanhand4-scenario2-dl'
      }
    ]
  },

  valve: {
    style: 'valve',
    path: 'lily/valve',
    texts: [
      `<span style="font-size: 150%; font-weight: bold;">Lily 2 - Valv'Friction</span> est un outil pédagogique de
        formation pour la pose et la gestion des valves bidirectionnelles.`,
      'Cet outil peut être utilisé par les EOH ou directement par les professionnels de santé.',
      'Vous trouverez ci-dessous un guide explicatif, une affiche pour annoncer la formation aux professionnels, et au choix, un diaporama commenté ou une vidéo.'
    ],
    cards: {
      guide: {
        type: 'Guide pratique',
        action: 'Télécharger',
        text: `Mettez en place vos sessions de formation grâce au guide pratique`,
        link: require('@/assets/documents/tools/lily/valve/SPIADI - Guide Pratique Lily 2.pdf')
      },

      poster: {
        type: 'Affiches',
        action: 'Télécharger',
        text: `Annoncez la date et le lieu de votre formation dans le service avec l'une de ces affiches`,
        link: 'https://l.spiadi.fr/lilyvalve-affiches'
      },

      slide: {
        type: 'Diaporama',
        action: 'Télécharger',
        text: `Présentez l'outil pédagogique à l'aide du diaporama animé`,
        link: 'https://l.spiadi.fr/lilyvalve-pptx'
      }
    },
    videos: [
      {
        dl: 'https://l.spiadi.fr/lilyvalve-dl2',
        url: 'https://l.spiadi.fr/lilyvalve2'
      }
    ]
  },

  cvp: {
    style: 'cvp',
    path: 'lily/cvp',
    texts: [
      `<span style="font-size: 150%; font-weight: bold;">Lily</span> est un outil pédagogique de
        formation pour la pose et la gestion des cathéters veineux périphériques courts et sous-cutanés.`,
      'Cet outil peut être utilisé par les EOH ou directement par les professionnels de santé.',
      'Vous trouverez ci-dessous un guide explicatif, une affiche pour annoncer la formation aux professionnels, et au choix, un diaporama commenté ou une vidéo.'
    ],
    cards: {
      guide: {
        type: 'Guide pratique',
        action: 'Télécharger',
        text: `Mettez en place vos sessions de formation grâce au guide pratique`,
        link: require('@/assets/documents/tools/lily/cvp/SPIADI - Guide Pratique Lily.pdf')
      },

      poster: {
        type: 'Affiche',
        action: 'Télécharger',
        text: `Annoncez la date et le lieu de votre formation dans le service avec cette affiche`,
        link: require('@/assets/documents/tools/lily/cvp/SPIADI - Affiche Lily.pdf')
      },

      slide: {
        type: 'Diaporama',
        action: 'Télécharger',
        text: `Présentez l'outil pédagogique à l'aide du diaporama animé`,
        link: 'https://l.spiadi.fr/lily-pptx'
      }
    },
    videos: [
      {
        dl: 'https://l.spiadi.fr/lilycvp-dl2',
        url: 'https://l.spiadi.fr/lilycvp2'
      }
    ]
  }
}
